import { OpenFeature } from "@openfeature/web-sdk";

export const TYPE_INSTITUTION = "institution";
export const TYPE_USER = "user";

const flagContext = (() => {
  const contextValues = {
    targetingKey: null,
    traits: {},
  };

  let lastSetContext = null;

  const getStoredContext = () => {
    try {
      const stored = localStorage.getItem("flagsmith_context");
      if (!stored) return null;

      const { context, timestamp } = JSON.parse(stored);
      const EXPIRATION_TIME = 30 * 60 * 1000; // 30 minutes
      const now = Date.now();

      if (now - timestamp > EXPIRATION_TIME) {
        localStorage.removeItem("flagsmith_context");
        return null;
      }

      return context;
    } catch (e) {
      console.warn("[flagContext] Failed to read stored context:", e);
      localStorage.removeItem("flagsmith_context");
      return null;
    }
  };

  const storeContext = (context) => {
    try {
      const storedData = {
        context: context,
        timestamp: Date.now(),
      };
      localStorage.setItem("flagsmith_context", JSON.stringify(storedData));
    } catch (e) {
      console.warn("[flagContext] Failed to store context:", e);
    }
  };
 
  // skip restoration in test environment to avoid interfering with tests
  if (import.meta.env.NODE_ENV !== 'test') {
    lastSetContext = getStoredContext();
    if (lastSetContext) {
      OpenFeature.setContext(lastSetContext);
    }
  }

  return {
    institute(institute) {
      contextValues.traits.institute = institute;
      return this;
    },

    user(user) {
      if (user?.["signInNames.emailAddress"]) {
        contextValues.traits.email = user["signInNames.emailAddress"];
      } else if (user?.email) {
        contextValues.traits.email = user.email;
      }
      return this;
    },

    email(email) {
      contextValues.traits.email = email;
      return this;
    },

    type(type) {
      contextValues.traits.type = type;
      return this;
    },

    ccmsVersion(version) {
      contextValues.traits.ccmsVersion = version;
      return this;
    },

    build() {
      const targetKey =
        contextValues.traits.email || contextValues.traits.institute;
      const newContext = {
        targetingKey: targetKey,
        traits: { ...contextValues.traits },
      };

      // only set context if it has actually changed
      const contextChanged =
        !lastSetContext ||
        lastSetContext.targetingKey !== newContext.targetingKey ||
        JSON.stringify(lastSetContext.traits) !==
          JSON.stringify(newContext.traits);

      if (contextChanged) {
        OpenFeature.setContext(newContext);
        lastSetContext = newContext;
        storeContext(newContext);
      }

      contextValues.targetingKey = null;
      contextValues.traits = {};

      return this;
    },

    restoreContext() {
      const storedContext = getStoredContext();
      if (storedContext) {
        OpenFeature.setContext(storedContext);
        lastSetContext = storedContext;
        return true;
      }
      return false;
    },

    clearStoredContext() {
      try {
        localStorage.removeItem("flagsmith_context");
        lastSetContext = null;
      } catch (e) {
        console.warn("[flagContext] Failed to clear stored context:", e);
      }
    },
  };
})();

export default flagContext;
